/**************************************************
 * Nombre:       Tarjetas_Actividades
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {WhatsApp} from '@mui/icons-material'
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjetas_Actividades = ({item, index}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                transition: "all .2s ease-in-out",
                boxShadow: '0px 10px 23px 9px rgba(0, 0, 0, 0.09)',
                borderRadius: 4,
                px: 4,
                pt: 2,
                pb: 4,
                border: 1,
                borderColor: '#ffffff00',
                backdropFilter: 'blur(4px)',
                '&:hover': {
                    borderColor: theme.palette.primary.main + 50
                }
            }}
        >

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <item.icono sx={{fill: '#00000080', width: sCell ? 42 : 64, height: sCell ? 42 : 64}}/>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                <Typography sx={{
                    fontFamily: 'Raleway',
                    color: theme.palette.info.main + 50,
                    fontSize: sCell ? 50 : 64,
                    fontWeight: 800,

                }}>{index + 1}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 24, fontWeight: 800, fontFamily: 'Raleway',  lineHeight: 1.2}}>{item.nombre}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{
                    fontSize: 16,
                    fontWeight: 300,
                    fontFamily: 'Raleway',
                    color: '#7A7A7A'
                }}>{item.descripcion}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Button
                    onClick={() => iniciarChatWass({mensaje: `Hola, quiero saber mas sobre: ${item.nombre} de Magaza Lodge`})}
                    sx={{pt: 1, pb: 0.7}}
                    color={'primary'} endIcon={<WhatsApp/>}

                >Mas Información</Button>
            </Grid>


        </Grid>
    )

}
export default Tarjetas_Actividades